var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('Snackbar'),_c('Navbar'),(_vm.$route.path !== '/')?_c('v-content',{staticClass:"mx-4 mb-3"},[_c('router-view')],1):_c('v-content',[_c('router-view')],1),_c('v-footer',[_c('v-spacer'),_c('div',[_vm._v("© 2021")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }